import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { sortBy } from 'lodash'
import { UserFragment } from '../../generated/graphql'

type Props = {
  users: UserFragment[]
}

export function UserGroupUserTable({ users }: Props): React.ReactElement {
  const { t } = useTranslation()

  if (!users.length) {
    return <Typography>{t('userGroups.users.empty')}</Typography>
  }

  const sortedUsers = sortBy(users, (user) =>
    user.displayName.toLocaleLowerCase(),
  )

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t('userGroups.users.name')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {sortedUsers.map((user) => (
          <TableRow key={user.id}>
            <TableCell>{user.displayName}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}
